export const states = [
  {
    name: "Western Australia",
    abbreviation: "WA",
  },
  {
    name: "Northern Territory",
    abbreviation: "NT",
  },
  {
    name: "South Australia",
    abbreviation: "SA",
  },
  {
    name: "Queensland",
    abbreviation: "QLD",
  },
  {
    name: "New South Wales",
    abbreviation: "NSW",
  },
  {
    name: "Victoria",
    abbreviation: "VIC",
  },
  {
    name: "Australian Capital Territory",
    abbreviation: "ACT",
  },
  {
    name: "Tasmania",
    abbreviation: "TAS",
  },
];
